import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { SearchService } from 'src/app/+search/search.service';

import { ErrorDetailsStore, SearchStore, SearchType, UsersStore } from '@store';

import { GatewayInvitationsService } from '../../../+installations/installation/gateway-features-panel/gateway-invitations.service';

@Component({
  selector: 'app-search-result-list',
  templateUrl: './search-result-list.component.html',
  styleUrls: ['./search-result-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultListComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  search$: BehaviorSubject<SearchType>;
  activeSearch$: BehaviorSubject<string>;
  dataSearchState$: Observable<any>;
  gatewayInvitationsLimit = 50;
  gatewayInvitationsOffset = 0;
  searchParams: any;
  searchType = SearchType;
  fetchLoading: boolean;
  companyNumber: string;

  // Emit clicked item id
  @Output() itemClick: EventEmitter<{ id: string; route: string }> = new EventEmitter<{
    id: string;
    route: string;
  }>();

  constructor(
    public searchService: SearchService,
    public searchStore: SearchStore,
    private cdr: ChangeDetectorRef,
    private errorDetailsStore: ErrorDetailsStore,
    private gatewayInvitationsService: GatewayInvitationsService,
    private usersStore: UsersStore
  ) {}

  ngOnInit(): void {
    this.search$ = this.searchService.search$;
    this.activeSearch$ = this.searchService.activeSearch$;
    this.assignSearchState();
  }

  assignSearchState(): void {
    this.search$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        map((searchType: SearchType) => {
          this.fetchLoading = false;
          switch (searchType) {
            case SearchType.boiler:
              this.dataSearchState$ = this.searchStore.getInstallations();
              break;

            case SearchType.gateway:
              this.dataSearchState$ = this.searchStore.getGateways();
              break;

            case SearchType.error:
              this.dataSearchState$ = this.searchStore.getErrors();
              break;

            case SearchType.user:
              this.dataSearchState$ = this.usersStore.getUsers();
              break;

            default:
              this.dataSearchState$ = this.usersStore.getUsers();
              break;
          }
          this.cdr.detectChanges();
        }),
        switchMap(() => this.dataSearchState$)
      )
      .subscribe((data) => {
        this.searchParams = data.searchParams;
        if (data.searchParams?.companyNumber && data.loading) {
          this.companyNumber = data.searchParams.companyNumber;
          this.gatewayInvitationsService.listGatewayInvitations({
            customerNumber: this.companyNumber,
            offset: this.gatewayInvitationsOffset,
            status: null,
            limit: this.gatewayInvitationsLimit,
          });
        }
      });
  }

  setFetchNext(): void {
    this.fetchLoading = true;
  }

  ngOnDestroy(): void {
    this.errorDetailsStore.clearErrorState();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
